export type { FontConnectorCapabilities, FontFamily, FontStyle } from '@chili-studio/connector-types';

export enum FontPreviewFormat {
    Square = 'square',
    Line = 'line',
}
